import { useMemo } from 'react';
import scheduleRaw from '../data/feeSchedule.json';

/** @type {{ standard: Record<string,string>; contracts: Record<string, Record<string,string>> }} */
const schedule = /** @type {any} */ (scheduleRaw);

/**
 * Payer-aware charge resolver. Keys in schedule.contracts.* must match
 * payer_id values returned by /payers/search/.
 *
 * @param {string|null|undefined} payerId
 */
export function useFeeSchedule(payerId) {
  return useMemo(() => {
    /** @type {Record<string,string>} */
    const contract = (payerId && schedule.contracts?.[payerId]) || {};
    /**
     * @param {string} cpt
     * @returns {{ amount: string|null; source: 'CONTRACT'|'STANDARD'|'NONE' }}
     */
    function resolveCharge(cpt) {
      if (cpt && Object.prototype.hasOwnProperty.call(contract, cpt)) {
        return { amount: contract[cpt], source: 'CONTRACT' };
      }
      const standard = schedule.standard?.[cpt];
      if (standard != null) return { amount: standard, source: 'STANDARD' };
      // No contract entry and no standard entry — caller should leave the
      // existing charge alone rather than zero it out. The fee schedule is
      // not yet populated for every CPT.
      return { amount: null, source: 'NONE' };
    }
    /**
     * @param {string|null|undefined} cpt
     * @returns {boolean}
     */
    function hasContractFor(cpt) {
      return cpt != null && Object.prototype.hasOwnProperty.call(contract, cpt);
    }
    return { resolveCharge, hasContractFor };
  }, [payerId]);
}
